import { ShieldCheck } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Section } from "@/components/LeadSections";

export const PRIVACY_URL = "https://www.iubenda.com/privacy-policy/11455963";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");

const Check = ({ id, checked, onChange, children, date, required }) => (
  <div className="flex items-start gap-3 rounded-xl border border-gray-200 bg-white p-4">
    <Checkbox
      id={id}
      data-testid={id}
      checked={checked}
      onCheckedChange={(v) => onChange(v === true)}
      className="mt-0.5 h-6 w-6 rounded-md border-2 border-buscema-green data-[state=checked]:bg-buscema-green data-[state=checked]:text-white"
    />
    <div className="space-y-1">
      <label htmlFor={id} className="text-sm leading-relaxed text-gray-700 cursor-pointer">
        {children} {required && <span className="text-tricolor-red">*</span>}
      </label>
      {checked && date && <p className="text-xs text-gray-400" data-testid={`${id}-date`}>Consenso registrato il {fmt(date)}</p>}
    </div>
  </div>
);

export const ConsentChecks = ({ form, set }) => (
  <Section icon={ShieldCheck} title="Consensi">
    <Check id="consent-privacy" checked={!!form.consenso_privacy} onChange={(v) => set("consenso_privacy", v)} date={form.consenso_privacy_data} required>
      Ho letto l'
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="privacy-policy-link"
        onClick={(e) => e.stopPropagation()}
        className="font-semibold text-buscema-green underline underline-offset-2 hover:text-buscema-gold"
      >
        informativa privacy
      </a>{" "}
      e acconsento al trattamento dei dati personali
    </Check>
    <Check id="consent-tracking-email" checked={!!form.consenso_tracking_email} onChange={(v) => set("consenso_tracking_email", v)} date={form.consenso_tracking_data}>
      Acconsento alla rilevazione delle aperture e dei clic delle email che ricevo, per misurarne l'efficacia. Posso revocare il consenso in ogni momento dal link in ogni email, continuando a ricevere le comunicazioni.
    </Check>
  </Section>
);

export const PRIVACY_ERROR = "Per salvare è necessario il consenso privacy";
